module.exports = __webpack_public_path__ + "img/debts.be7019c2.svg";